import React from 'react';

export default function CategoryRow({
  category,
  catIndex,
  updateCategoryName,
  removeCategory,
  t,
  isReadOnly = false,
}) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-3 hover:border-gray-300 transition-all">
      <input
        type="text"
        className="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-orange-400 focus:ring-1 focus:ring-orange-400 focus:outline-none transition"
        value={category.name}
        onChange={(e) => updateCategoryName(catIndex, e.target.value)}
        disabled={isReadOnly}
        placeholder={t(
          'accommodation.categoryPlaceholder',
          'e.g. 3 stars or Standard',
        )}
      />
      {!isReadOnly && (
        <button
          type="button"
          onClick={() => removeCategory(catIndex)}
          className="flex-shrink-0 p-1 border-none outline-none text-gray-300 hover:text-red-500 transition"
          title={t('accommodation.removeCategory', 'Remove category')}
        >
          <i className="fa-light fa-trash" style={{ fontSize: 15 }} />
        </button>
      )}
    </div>
  );
}
